import { render, staticRenderFns } from "./BaseTableFilterTags.vue?vue&type=template&id=6ce6515d&scoped=true"
import script from "./BaseTableFilterTags.vue?vue&type=script&lang=js"
export * from "./BaseTableFilterTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce6515d",
  null
  
)

export default component.exports